import type { Sanction, NiveauSanction } from '@shared/types/Sanction';

/**
 * Service de gestion des sanctions disciplinaires (Loi 3/94 + jurisprudence OHADA).
 * Échelle graduée : avertissement oral -> écrit -> blâme -> mise à pied -> rétrogradation -> licenciement pour faute.
 */
export class SanctionsService {
  static readonly NIVEAUX_ORDONNES: readonly NiveauSanction[] = [
    'avertissement_oral',
    'avertissement_ecrit',
    'blame',
    'mise_a_pied',
    'retrogradation',
    'licenciement_faute',
  ];

  /** Compte les sanctions actives d'un salarié sur les 12 derniers mois. */
  static compterRecentes(
    sanctions: readonly Sanction[],
    salarie_id: string,
    dateRef: Date = new Date(),
  ): number {
    const il_y_a_12_mois = new Date(dateRef.getTime() - 365 * 24 * 3600 * 1000);
    return sanctions.filter(
      (s) => s.salarie_id === salarie_id && new Date(s.date) >= il_y_a_12_mois,
    ).length;
  }

  /** Détermine le niveau de sanction recommandé selon l'historique. */
  static recommander(historique: readonly Sanction[], salarie_id: string): NiveauSanction {
    const recentes = historique.filter((s) => s.salarie_id === salarie_id);
    if (recentes.length === 0) return 'avertissement_oral';
    const derniere = recentes.slice().sort((a, b) => b.date.localeCompare(a.date))[0]!;
    const idx = this.NIVEAUX_ORDONNES.indexOf(derniere.niveau);
    return this.NIVEAUX_ORDONNES[Math.min(idx + 1, this.NIVEAUX_ORDONNES.length - 1)]!;
  }
}
